var Login_1;
import { __decorate } from "tslib";
import { html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '@material/mwc-button';
import { AuthService } from '../common/authentication/authService.js';
import { RxElement } from '../common/reactiveX/rxElement.js';
import { subscribe } from '../common/reactiveX/rxElementDecorators.js';
let Login = Login_1 = class Login extends RxElement {
    connectedCallback() {
        var _a;
        (_a = super.connectedCallback) === null || _a === void 0 ? void 0 : _a.call(this);
        const blueDiv = document.getElementById('blue');
        if (blueDiv) {
            blueDiv.style.display = 'none';
        }
    }
    disconnectedCallback() {
        var _a;
        (_a = super.disconnectedCallback) === null || _a === void 0 ? void 0 : _a.call(this);
        const blueDiv = document.getElementById('blue');
        if (blueDiv) {
            blueDiv.style.display = '';
        }
    }
    // Make renderLogo a static method since it doesn't use 'this'
    static renderLogo() {
        return html `
      <svg
        id="splash-loadingLogo"
        x="0px"
        y="0px"
        viewBox="0 0 39.7 40.1"
        xml:space="preserve"
      >
        <g>
          <radialGradient
            id="SVGID_1_"
            cx="19.9065"
            cy="22.0543"
            r="19.9357"
            gradientTransform="matrix(1 0 0 -1 0 42.0012)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.3313" class="stop1"></stop>
            <stop offset="0.3977" class="stop2"></stop>
            <stop offset="0.5009" class="stop3"></stop>
            <stop offset="0.6278" class="stop4"></stop>
            <stop offset="0.7736" class="stop5"></stop>
            <stop offset="0.9333" class="stop6"></stop>
            <stop offset="0.9939" class="stop7"></stop>
          </radialGradient>
          <path
            class="st0"
            d="M17.7,18.5c-4.1,11-14.1,12.6-15.5,13.2c-0.7,0.3-0.3,0.5,0,0.4
              c0.5,0,1.1-0.1,1.3-0.1c0.6,0,0.7,0,1.1,0.4c0.3,0.5,1.9,2.2,1.9,2.2
              c9.1-2.5,12.1-10.7,13.9-16.2L17.7,18.5z
              M35.1,7.3c-2.6,1-9.3,4-11.8,9.9c2.9,0,5.9,0.1,6.9,0.1
              c1.6,0,2.1,0.8-0.2,0.8c-2.5,0.2-7,0.4-7,0.4c-1,2.6-4.2,14.6-16.5,16.8
              c-1.4,0.2-0.6,0.6-0.1,0.6c0.3,0,0.7,0,0.9,0c0.2,0,0.5,0.1,0.7,0.3
              c1.1,0.9,5.1,3.8,11.4,3.9c9.1,0.1,14.7-6,15.5-7c0.9-1,4.7-5.6,4.8-12.6
              S36,8.7,35.8,8.4s-0.5-0.6,0-0.8c0.3-0.1,0.4-0.3,0.1-0.4
              C36,7.1,35.6,7.1,35.1,7.3z
              M30.6,3.1c-9.5,3.4-11.8,12.3-12.5,14.1c0.7,0,1.8,0,2.6-0.1
              C22,14.7,24.4,9,34.6,6.6c-0.5-0.6-2.5-2.3-2.8-2.5c-0.2-0.2-0.6-0.6,0-0.9
              c0.6-0.2,0.3-0.3,0-0.3C31.4,2.9,31.2,2.9,30.6,3.1z
              M19.9,0c-0.2,0-0.4,0-0.6,0c-6.7,0.2-11.4,3.2-15,7.4S0.1,17,0.1,18.5
              C0,20-0.4,25,3.2,30.7c9.6-4.1,11.9-11.7,12.4-12.9c-1,0-3.3,0.2-3.9,0.3
              c-0.4,0-1.4,0.1-1.9-0.2c-0.7-0.5,0.2-0.6,1.2-0.8c0.6-0.1,5.1-0.6,5.1-0.6
              c0.4-1.3,2.7-11.2,13.7-13.8C29.8,2.7,26.3,0.1,19.9,0L19.9,0L19.9,0z"
          ></path>
          <radialGradient
            id="SVGID_2_"
            cx="19.9065"
            cy="22.0543"
            r="19.9357"
            gradientTransform="matrix(1 0 0 -1 0 42.0012)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2086" class="stop1"></stop>
            <stop offset="0.9325" class="stop8"></stop>
          </radialGradient>
          <path
            class="st1"
            d="M17.7,18.5c-4.1,11-14.1,12.6-15.5,13.2c-0.7,0.3-0.3,0.5,0,0.4
              c0.5,0,1.1-0.1,1.3-0.1c0.6,0,0.7,0,1.1,0.4c0.3,0.5,1.9,2.2,1.9,2.2
              c9.1-2.5,12.1-10.7,13.9-16.2L17.7,18.5z
              M35.1,7.3c-2.6,1-9.3,4-11.8,9.9c2.9,0,5.9,0.1,6.9,0.1
              c1.6,0,2.1,0.8-0.2,0.8c-2.5,0.2-7,0.4-7,0.4c-1,2.6-4.2,14.6-16.5,16.8
              c-1.4,0.2-0.6,0.6-0.1,0.6c0.3,0,0.7,0,0.9,0c0.2,0,0.5,0.1,0.7,0.3
              c1.1,0.9,5.1,3.8,11.4,3.9c9.1,0.1,14.7-6,15.5-7c0.9-1,4.7-5.6,4.8-12.6
              S36,8.7,35.8,8.4s-0.5-0.6,0-0.8c0.3-0.1,0.4-0.3,0.1-0.4
              C36,7.1,35.6,7.1,35.1,7.3z
              M30.6,3.1c-9.5,3.4-11.8,12.3-12.5,14.1c0.7,0,1.8,0,2.6-0.1
              C22,14.7,24.4,9,34.6,6.6c-0.5-0.6-2.5-2.3-2.8-2.5c-0.2-0.2-0.6-0.6,0-0.9
              c0.6-0.2,0.3-0.3,0-0.3C31.4,2.9,31.2,2.9,30.6,3.1z
              M19.9,0c-0.2,0-0.4,0-0.6,0c-6.7,0.2-11.4,3.2-15,7.4S0.1,17,0.1,18.5
              C0,20-0.4,25,3.2,30.7c9.6-4.1,11.9-11.7,12.4-12.9c-1,0-3.3,0.2-3.9,0.3
              c-0.4,0-1.4,0.1-1.9-0.2c-0.7-0.5,0.2-0.6,1.2-0.8c0.6-0.1,5.1-0.6,5.1-0.6
              c0.4-1.3,2.7-11.2,13.7-13.8C29.8,2.7,26.3,0.1,19.9,0L19.9,0L19.9,0z"
          ></path>
        </g>
      </svg>
    `;
    }
    render() {
        return html `
      <div id="splash">
        <div id="splash-content">
          ${Login_1.renderLogo()}
          <div id="splash-label">
            ${this.blueUser.status === 'LOADING'
            ? html `
                  <div>
                    <span id="splash__text">Securing your connection...</span>
                    <span id="splash__action">&nbsp;</span>
                  </div>
                `
            : html `
                  <div>
                    <span id="splash__text">Authorized Users Only</span>
                    <mwc-button
                      outlined
                      label="Login"
                      id="splash__action"
                      @click="${() => AuthService.signInViaRedirect()}"
                    ></mwc-button>
                  </div>
                `}
          </div>
        </div>
      </div>
    `;
    }
};
Login.styles = css `
    /* Define CSS variables for reusability and easier maintenance */
    :host {
      --primary-color: #12447c;
      --on-primary-color: white;
      --font-family: 'Roboto', Helvetica, Arial, sans-serif;
      --font-size: calc(12px + 2vh + 0.2vmin);
    }

    mwc-button {
      --mdc-theme-primary: var(--primary-color);
      --mdc-theme-on-primary: var(--on-primary-color);
      --mdc-typography-button-font-family: var(--font-family);
      --mdc-typography-button-font-size: var(--font-size);
    }

    /* Splash screen styles */
    #splash {
      height: 100vh;
      font-size: var(--font-size);
    }

    #splash-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 100%;
    }

    #splash-loadingLogo {
      max-width: 60%;
      max-height: 60vh;
    }

    #splash-label {
      padding-top: 5px;
      font-weight: 300;
      transition: all 1s ease-in-out;
    }

    #splash__text {
      margin: 15px 0;
      display: block;
    }

    #splash__action {
      margin: 0 auto;
    }

    /* SVG styles */
    .st0 {
      fill: url(#SVGID_1_);
    }

    .st1 {
      fill: url(#SVGID_2_);
    }

    .stop1 {
      stop-color: #1284af;
    }
    .stop2 {
      stop-color: #2687b1;
    }
    .stop3 {
      stop-color: #4791b8;
    }
    .stop4 {
      stop-color: #6ca1c3;
    }
    .stop5 {
      stop-color: #9cbcd4;
    }
    .stop6 {
      stop-color: #dde6ee;
    }
    .stop7 {
      stop-color: #ffffff;
    }
    .stop8 {
      stop-color: #00437a;
    }
  `;
__decorate([
    subscribe(),
    state()
], Login.prototype, "blueUser", void 0);
Login = Login_1 = __decorate([
    customElement('blue-login')
], Login);
export { Login };
//# sourceMappingURL=login.js.map